module.exports = __webpack_public_path__ + "@/assets/img/companies.6ec81e3c.svg";